import React from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import StoreSelector from "./StoreSelector";
import ProfileCircle from "Components/Profile";
import ReloadSite from "Components/Refresh";
import TestMqttButton from "./TestMqttButton";

const Header = () => {
  return (
    <Navbar className="header" expand="lg" bg="white">
      <Container fluid>
        <Navbar.Brand className="d-flex align-items-center justify-content-center gap-2">
          {/* <img
            alt=""
            src={require("../../Assets/Images/FoodLift-Red.png")}
            height="50px"
            width="58px"
            className="d-inline-block align-top rounded"
          />{" "} */}
          <img
            alt=""
            src={require("../../Assets/Images/foodslift-logo-square-red-512.png")}
            height="55px"
            width="auto"
            className=" d-inline-block align-top rounded"
          />{" "}
        </Navbar.Brand>

        <div className="d-flex align-items-center justify-content-end gap-2">
          <TestMqttButton />
          <ReloadSite />
          <StoreSelector />
          <ProfileCircle />
        </div>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
      </Container>
    </Navbar>
  );
};

export default Header;
